import { exists } from '@/helpers/utilities';

export let mixin = () => {
    let state = {
        loginSkiptoLoginLink: document.getElementById('login-form-skip-link'),
        triggers: document.querySelectorAll(`[data-js="login-trigger"]`),
        modal: document.querySelector(`[data-js="login-form"]`),
        userName: document.querySelector(`[data-js="login-form"] [name="UserName"]`),
        password: document.querySelector(`[data-js="login-form"] [name="Password"]`),
        submit: document.querySelector(`[data-js="login-form"] [type="submit"]`),
        closeBtn: document.querySelector(`[data-js="login-form"] .cu-login-form__close`),
        isOpen: false,
        justOpened: false,
        openEvent: new CustomEvent('modalOpen'),
        trap: null,
        get tabbableElements() {
            return this.modal
                ? this.modal.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]')
                : [];
        }
    };
    
    let module = {
        focusTrap() {
            state.trap = focusTrap.createFocusTrap(state.modal, {
                allowOutsideClick: true,
                setReturnFocus: () => {
                    const activeTrigger = document.querySelector('[data-js="login-trigger"][aria-expanded="true"]');
                    console.log(activeTrigger);
                },
                onPostDeactivate: () => {
                    setTimeout(() => {
                        const activeTrigger = document.querySelector('[data-js="login-trigger"][aria-expanded="true"]');
                        if (activeTrigger) {
                            activeTrigger.setAttribute('aria-expanded', 'false');
                            activeTrigger.focus();
                        }
                    }, 50); // Slight delay ensures FocusTrap returns focus first
                }
            });
        },
        enableTabIndex() {
            state.tabbableElements.forEach(function(element) {
                element.setAttribute('tabindex', '4');
            });
            state.userName.setAttribute('tabindex', '1');
            state.password.setAttribute('tabindex', '2');
            state.submit.setAttribute('tabindex', '3');
            state.closeBtn.setAttribute('tabindex', '5');
        },
        disableTabIndex() {
            state.tabbableElements.forEach(function(element) {
                element.setAttribute('tabindex', '-1');
                element.blur();
            });
        },
        focusInput() {
            if (!exists(state.userName)) return;
            state.userName.focus();
        },
        toggleModal() {
            let method = state.isOpen ? 'remove' : 'add';
            state.modal.classList[method](`js-is-active`);
        
            state.modal.setAttribute('aria-hidden', state.modal.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
        
            state.isOpen = !state.isOpen;
            if (state.isOpen) {
                this.enableTabIndex();
                this.focusInput();
                this.announceOpen();
                this.focusTrap();
                state.trap.activate();
            } else if (state.trap) {
                // console.log(document.querySelector('[data-js="login-trigger"][aria-expanded="true"]'));
                this.disableTabIndex()
                state.trap.deactivate();
            }
        },
        onModalOpen() {
            if (state.justOpened) return;
            if (!state.isOpen) return;
            this.toggleModal();
        },
        announceOpen() {
            state.justOpened = true;
            window.dispatchEvent(state.openEvent);

            setTimeout(() => {
                state.justOpened = false;
            }, 500);
        },
        setEventBindings() {
            if (!state.triggers.length) return;
        
            [...state.triggers].forEach((trigger) => {
                trigger.addEventListener('click', (event) => {
                    event.preventDefault();
                    if( !trigger.classList.contains('cu-login-form__close') ) {
                        trigger.setAttribute('aria-expanded', trigger.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
                    }
                    this.toggleModal();
                });
            });
        
            window.addEventListener('modalOpen', this.onModalOpen.bind(this));
        },

        init() {
            if (!exists(state.modal)) {
                state.loginSkiptoLoginLink.remove();
                return;
            }
            this.focusTrap();
            this.disableTabIndex();
            this.setEventBindings();
        },
    };

    return module.init();
};

export default {
    init() {
        return mixin();
    },
};